import { setCaseIdData } from '@/store';
import { api } from '../core';

export type CaseCreateCancelResponse = object;

type CaseCreateCancelProps = {
  abortController?: AbortController;
  caseId: string;
};

const caseCreateCancelApi = api.injectEndpoints({
  endpoints: (builder) => ({
    postCaseCreateCancel: builder.query<CaseCreateCancelResponse, CaseCreateCancelProps>({
      query: ({ abortController = new AbortController(), caseId }: CaseCreateCancelProps) => ({
        url: `case/create/cancel`,
        method: 'POST',
        body: {
          case_id: caseId
        },
        signal: abortController.signal
      }),
      async onQueryStarted(_, { dispatch, queryFulfilled }) {
        try {
          await queryFulfilled;

          dispatch(setCaseIdData(null));
        } catch (error) {
          if (error instanceof Error && error.name === 'AbortError') {
            console.log('Request was aborted');
          } else {
            console.error('Error in postCaseCreateCancel in onQueryStarted:', error);
          }
        }
      },
      extraOptions: { maxRetries: 0 }
    })
  })
});

/**
 * Export hooks for usage in functional components, which are
 * auto-generated based on the defined endpoints
 */
export const { useLazyPostCaseCreateCancelQuery } = caseCreateCancelApi;
